import React from 'react';
import { Form, Row, Col, FormInstance } from 'antd';

export interface TypeStepDataProps {
  activation?: 'OTAA' | 'ABP';
  encryption?: 'NS' | 'APP';
  isUpload?: boolean;
}
interface TypeStepProps {
  form: FormInstance<TypeStepDataProps>;
  renderRadioItem: (
    name: string,
    options: string[],
    help?: string,
  ) => JSX.Element;
}

const TypeStep = ({ form, renderRadioItem }: TypeStepProps) => (
  <Form
    colon={false}
    form={form}
    labelCol={{ span: 24 }}
    wrapperCol={{ span: 24 }}
    scrollToFirstError
    initialValues={{ activation: 'OTAA', encryption: 'NS' }}
    layout="vertical"
  >
    <Row gutter={[8, 8]} justify="center">
      <Col xs={24} sm={8}>
        {renderRadioItem('activation', ['OTAA', 'ABP'])}
      </Col>
      <Col xs={24} sm={8}>
        {renderRadioItem('encryption', ['NS', 'APP'])}
      </Col>
    </Row>
  </Form>
);

export default TypeStep;
